export default function PrimaryBtn(props){
    return(
        <button className="primarybtn">
            {props.btntext}
        </button>
    )
}